.overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
  padding: var(--space-4);
  background: rgb(21 23 41 / 0.6);
}

.overlay[data-entering] {
  animation: fade var(--motion-standard) var(--motion-ease);
}

.overlay[data-exiting] {
  animation: fade var(--motion-fast) var(--motion-ease) reverse;
}

.modal {
  width: min(100%, 560px);
  max-height: calc(100dvh - 2 * var(--space-4));
  border: var(--border-default) solid var(--color-border-strong);
  border-radius: var(--radius-surface);
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-modal);
  overflow: auto;
}

.modal[data-entering] {
  animation: rise var(--motion-standard) var(--motion-ease);
}

.wide {
  width: min(100%, 880px);
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(var(--motion-travel));
  }
}

.dialog {
  outline: none;
}

.header {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
  border-bottom: var(--border-default) solid var(--color-border-subtle);
  background: var(--color-bg-surface);
}

.title {
  margin: 0;
  font: var(--type-h3);
  letter-spacing: var(--tracking-h3);
}

.body {
  display: grid;
  gap: var(--space-5);
  padding: var(--space-6);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-6) var(--space-6);
}

.popover {
  max-width: min(360px, calc(100vw - 2 * var(--space-4)));
  border: var(--border-default) solid var(--color-border-strong);
  border-radius: var(--radius-surface);
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-modal);
}

.popover[data-entering] {
  animation: rise var(--motion-fast) var(--motion-ease);
}

.popoverDialog {
  display: grid;
  justify-items: start;
  gap: var(--space-3);
  padding: var(--space-5);
  outline: none;
}

.popoverTitle {
  margin: 0;
  font: var(--type-h4);
}

.popoverBody {
  color: var(--color-content-secondary);
  font: var(--type-compact);
}
